import { BEFORE_RANKING, GET_RANKINGS } from '../../redux/types';

const initialState = {
    stats: null,
    statsAuth: false
}

export default function rankRed(state = initialState, action) {
    switch (action.type) {
        case GET_RANKINGS:
            return {
                ...state,
                stats: action.payload,
                statsAuth: true
            }
        case BEFORE_RANKING:
            return {
                ...state,
                stats: null,
                statsAuth: false
            }
        default:
            return {
                ...state
            }
    }
}